import React from 'react';
import { array, string, bool, func, object } from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { translate } from 'react-i18next';

import { BaseFooter } from '@snapask/common-components';
import cookie from '@snapask/common-components/dist/utils/cookie';
import { USER_LNG } from '@snapask/common-components/dist/constants/cookieNames';
import { setBodyLanguage } from '@snapask/common-components/dist/services/language';

import Link from '@dragonfruit/components/Link';
import { HOME_DOWNLOAD_CLICK } from '@dragonfruit/constants/gtmEvents';
import { ANDROID, IOS } from '@dragonfruit/constants/appDownloadType';

import config from '@dragonfruit/config';
const { CAREER_WEBFLOW_DOMAIN } = config;

import {
  fetchSiteInfo,
  getZendeskFAQLink,
  getOfferingList,
  getMultipleOfferingMode,
  getShowLiveInstructorBtn,
} from '@dragonfruit/redux/siteInfo';
import {
  generateOfficialSiteURL,
  generateAcademyURL,
} from '@dragonfruit/redux/navigation';
import { saveLocale, getLocaleCode } from '@dragonfruit/redux/locale';
import { getRegion } from '@dragonfruit/redux/locale';
import { sendGtmEvent } from '@dragonfruit/redux/googleTagManager';

function SnapaskFooter({
  userRegion,
  getAcademyURL,
  getOfficialSiteURL,
  offerings,
  t,
  zendeskFAQUrl,
  multipleOfferingMode,
  changeLocale,
  currentLocale,
  showLiveInstructorBtn,
  i18n,
  sendGtmEvent,
}) {
  const handleChangeLocale = (selectedLocale, lang) => {
    // update application wise locale.
    changeLocale({
      localeCode: selectedLocale,
      language: lang,
      region: selectedLocale.slice(-2),
    });

    // update cookie
    const snapCookie = new cookie(config.COOKIE_DOMAIN);
    snapCookie.setCookie(USER_LNG, lang);

    setBodyLanguage(window, lang);

    fetchSiteInfo();

    i18n.changeLanguage(selectedLocale, () => {
      const path = location.pathname.replace(currentLocale, selectedLocale);
      location.pathname = path;
    });
  };

  const onIosDownloadClick = () => {
    sendGtmEvent({
      eventName: HOME_DOWNLOAD_CLICK,
      data: {
        region: userRegion,
        type: IOS,
      },
    });
  };

  const onAndroidDownloadClick = () => {
    sendGtmEvent({
      eventName: HOME_DOWNLOAD_CLICK,
      data: {
        region: userRegion,
        type: ANDROID,
      },
    });
  };

  return (
    <BaseFooter
      userRegion={userRegion}
      currentLocale={currentLocale}
      getAcademyURL={getAcademyURL}
      getOfficialSiteURL={getOfficialSiteURL}
      LinkComponent={Link}
      onIosDownloadClick={onIosDownloadClick}
      onAndroidDownloadClick={onAndroidDownloadClick}
      onSelectLocale={handleChangeLocale}
      zendeskFAQUrl={zendeskFAQUrl}
      offerings={offerings}
      multipleOfferingMode={multipleOfferingMode}
      careerSiteEndpoint={CAREER_WEBFLOW_DOMAIN}
      showInstructorLink={showLiveInstructorBtn}
      t={t}
    />
  );
}

SnapaskFooter.propTypes = {
  changeLocale: func.isRequired,
  currentLocale: string.isRequired,
  getAcademyURL: func.isRequired,
  getOfficialSiteURL: func.isRequired,
  i18n: object.isRequired,
  multipleOfferingMode: bool.isRequired,
  offerings: array.isRequired,
  sendGtmEvent: func.isRequired,
  showLiveInstructorBtn: bool.isRequired,
  t: func.isRequired,
  zendeskFAQUrl: string.isRequired,
  userRegion: string,
};

export default compose(
  translate(['navigation', 'footer']),
  connect(
    state => ({
      zendeskFAQUrl: getZendeskFAQLink(state),
      offerings: getOfferingList(state),
      multipleOfferingMode: getMultipleOfferingMode(state),
      getAcademyURL: generateAcademyURL(state),
      getOfficialSiteURL: generateOfficialSiteURL(state),
      currentLocale: getLocaleCode(state),
      showLiveInstructorBtn: getShowLiveInstructorBtn(state),
      userRegion: getRegion(state),
    }),
    {
      changeLocale: saveLocale,
      sendGtmEvent,
    }
  )
)(SnapaskFooter);



// WEBPACK FOOTER //
// ./app/components/SnapaskFooter/SnapaskFooter.jsx